export * from './paginated-list.component';
export * from './paginated-list.module';
